var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var FlickrFilledIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 64
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM28.0039 32C28.0039 36.4183 24.4222 40 20.004 40C15.5857 40 12.004 36.4183 12.004 32C12.004 27.5817 15.5857 24 20.004 24C24.4222 24 28.0039 27.5817 28.0039 32ZM44.004 40C48.4223 40 52.004 36.4183 52.004 32C52.004 27.5817 48.4223 24 44.004 24C39.5857 24 36.004 27.5817 36.004 32C36.004 36.4183 39.5857 40 44.004 40Z"
  }));
};
export var FlickrFilledIconGlyph = function (props) {
  return React.createElement(FlickrFilledIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};